import * as ValidateModel from '../../shared/ValidateModel';

class Design {
    readonly id: number;

    readonly idProduct: number;

    readonly designName: string;

    readonly garmentName: string;

    readonly dateAdd: string;

    readonly dateUpd: string;

    constructor(
        id: number,
        idProduct: number,
        designName: string,
        garmentName: string,
        dateAdd: string,
        dateUpd: string
    ) {
        ValidateModel.isNumber(id, 'id');
        ValidateModel.isNumber(idProduct, 'idProduct');
        ValidateModel.isString(designName, 'designName');
        ValidateModel.isString(garmentName, 'garmentName');
        ValidateModel.isString(dateAdd, 'dateAdd');
        ValidateModel.isString(dateUpd, 'dateUpd');

        this.id = id;
        this.idProduct = idProduct;
        this.designName = designName;
        this.garmentName = garmentName;
        this.dateAdd = dateAdd;
        this.dateUpd = dateUpd;
    }

    getId = (): number => this.id;

    getIdProduct = (): number => this.idProduct;

    getDesignName = (): string => this.designName;

    getGarmentName = (): string => this.garmentName;

    getDateAdd = (): string => this.dateAdd;

    getDateUpd = (): string => this.dateUpd;
}

export default Design;
